import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import EnquiryForm from "./EnquiryForm";

import { useEffect } from "react";
import { pick } from "../lib/leadFields";
import { trackProduct } from "../lib/tracking";

const FIELDS = pick("name", "phone", "whatsapp", "business_type", { name: "city", label: "City / Delivery location" }, "state", "quantity", { name: "message", label: "Message", type: "textarea", full: true });

export default function ProductEnquiryDialog({ product, onClose }) {
  useEffect(() => {
    if (product?.name) trackProduct(product.name);
  }, [product]);
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="product-enquiry-dialog" className="max-h-[90vh] overflow-y-auto sm:max-w-xl" data-lenis-prevent>
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-bold uppercase text-navy">Product enquiry</DialogTitle>
          <DialogDescription>{product?.name}{product?.pack_size ? ` · ${product.pack_size}` : ""}</DialogDescription>
        </DialogHeader>
        {product && (
          <EnquiryForm
            type="product"
            testPrefix="product-enquiry"
            fields={FIELDS}
            extraDetails={{ Product: `${product.name}${product.pack_size ? ` (${product.pack_size})` : ""}` }}
            waText={`Hello MHM SUPER ADBLUE, I am interested in ${product.name}.`}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
